<template>
  <div>


    <a class='my-5 flex gap-2 justify-center items-center' @click='onClickPACIApp'>
      <img :src="require('../assets/paci_icon.png')" alt='paci-icon' />
      {{ $t('ClickHerePACIApp') }}
    </a>


    <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" class='flex items-center gap-3'>

      <img :class="{'opacity-25': carouselIndex === 0 }"
           :src="require(`../assets/${$i18n.locale === 'en' ? 'left_arrow.png' : 'right_arrow.png'}`)"
           alt='left'
           style='z-index: -1'
           role='button'
           @click='onClickCarouselLeft'>

      <div class='flex-grow'>
        <p class='font-bold flex justify-center top-6'>
          {{ $t('Step') }} {{ carouselIndex + 1 }} / 8
        </p>
        <b-carousel v-model='carouselIndex' :arrow='false' :autoplay='false'
                    :indicator='false' :pause-info='false' :repeat='false' class='flex-grow'
                    has-drag @click.native='onClickCarouselItem'>

          <b-carousel-item v-for='(_, i) in tutorial[tutorialName]' :key='i'>
            <img :src='require(`../assets/tutorial/${tutorialName}/${$i18n.locale}/${i+1}.png`)'
                 alt='tutorial'
                 class='h-96 sm:h-auto mx-auto'
                 role='button'>
          </b-carousel-item>
        </b-carousel>
      </div>
      <img :class="{'opacity-25': carouselIndex === tutorial[tutorialName].length - 1 }"
           :src="require(`../assets/${$i18n.locale === 'ar' ? 'left_arrow.png' : 'right_arrow.png'}`)"
           alt='right'
           style='z-index: -1'
           role='button' @click='onClickCarouselRight'>
    </div>
    <p class='text-center mt-5 p-2 text-black bg-gray-100 rounded-md'>
      {{ tutorial[tutorialName][carouselIndex][$i18n.locale] }}</p>


  </div>
</template>

<script>
import tutorial from '../tutorial.json'
import { BCarousel, BCarouselItem } from 'buefy/dist/components/carousel'

export default {
  name: 'Tutorial',
  components: {BCarousel, BCarouselItem},
  props: {
    tutorialName: {
      type: String,
      default: 'enable_auth'
    }
  },
  data() {
    return {
      carouselIndex: 0,
      tutorial
    }
  },
  computed: {
    userAgent() {
      return navigator.userAgent || navigator.vendor || window.opera
    },
    isAndroid() {
      return this.userAgent.includes('Android')
    },
    isHuawei() {
      let isIncluded = false
      const huaweiWords = ['ALP-', 'AMN-', 'ANA-', 'ANE-', 'ANG-', 'AQM-', 'ARS-', 'ART-', 'ATU-', 'BAC-', 'BLA-', 'BRQ-', 'CAG-', 'CAM-', 'CAN-', 'CAZ-', 'CDL-', 'CDY-', 'CLT-', 'CRO-', 'CUN-', 'DIG-', 'DRA-', 'DUA-', 'DUB-', 'DVC-', 'ELE-', 'ELS-', 'EML-', 'EVA-', 'EVR-', 'FIG-', 'FLA-', 'FRL-', 'GLK-', 'HMA-', 'HW-', 'HWI-', 'INE-', 'JAT-', 'JEF-', 'JER-', 'JKM-', 'JNY-', 'JSC-', 'LDN-', 'LIO-', 'LON-', 'LUA-', 'LYA-', 'LYO-', 'MAR-', 'MED-', 'MHA-', 'MLA-', 'MRD-', 'MYA-', 'NCE-', 'NEO-', 'NOH-', 'NOP-', 'OCE-', 'PAR-', 'PIC-', 'POT-', 'PPA-', 'PRA-', 'RNE-', 'SEA-', 'SLA-', 'SNE-', 'SPN-', 'STK-', 'TAH-', 'TAS-', 'TET-', 'TRT-', 'VCE-', 'VIE-', 'VKY-', 'VNS-', 'VOG-', 'VTR-', 'WAS-', 'WKG-', 'WLZ-', 'YAL']
      for (let i = 0; i < huaweiWords.length; i++) {
        if (this.userAgent.includes(huaweiWords[i])) {
          isIncluded = true
          break
        }
      }
      return isIncluded
    },
    isIOS() {
      return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        || (this.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  methods: {
    onClickCarouselRight() {
      if (this.carouselIndex < this.tutorial[this.tutorialName].length - 1)
        this.carouselIndex++
    },

    onClickCarouselLeft() {
      if (this.carouselIndex > 0)
        this.carouselIndex--
    },

    onClickCarouselItem(e) {
      if (e.isTrusted) {
        window.open('https://youtu.be/7v5e7tqwECg')
      }
    },
    onClickPACIApp() {
      if (this.isAndroid) {
        const fallBack = this.isHuawei ? 'https%3A%2F%2Fappgallery.huawei.com%2Fapp%2FC103456279'
          : 'https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dkw.gov.paci.PACIMobileID'
        window.open(`intent://Send#Intent;scheme=pacimid;S.browser_fallback_url=${ fallBack };end`, '_self')
      } else if (this.isIOS) {
        let s = window.open('pacimid://')
        s.setTimeout(() => {
          s.window.location = 'https://apps.apple.com/kw/app/kuwait-mobile-id-%D9%87%D9%88%D9%8A%D8%AA%D9%8A/id1449712307'
        }, 1000)

      } else {
        alert('Use a mobile device please')
      }
    }
  },
  mounted() {
    this.$store.state.navText = ''
  }
}
</script>

<style scoped></style>
